import { JSX } from 'react'

import { IconProps } from '../../icon'

const Pages: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M35.4872 12H17.4359C14.9415 12 12.9231 14.0185 12.9231 16.5128V16.9231H12.5128C10.0185 16.9231 8 18.9415 8 21.4359V31.2821C8 33.7764 10.0185 35.7949 12.5128 35.7949H30.5641C33.0585 35.7949 35.0769 33.7764 35.0769 31.2821V21.4359C35.0769 18.9415 33.0585 16.9231 30.5641 16.9231H15.3846V16.5128C15.3846 15.3805 16.3036 14.4615 17.4359 14.4615H35.4872C36.6195 14.4615 37.5385 15.3805 37.5385 16.5128V29.641C37.5385 30.3138 38.0964 30.8718 38.7692 30.8718C39.4421 30.8718 40 30.3138 40 29.641V16.5128C40 14.0185 37.9815 12 35.4872 12ZM32.6154 21.4359V31.2821C32.6154 32.4144 31.6964 33.3333 30.5641 33.3333H12.5128C11.3805 33.3333 10.4615 32.4144 10.4615 31.2821V21.4359C10.4615 20.3036 11.3805 19.3846 12.5128 19.3846H30.5641C31.6964 19.3846 32.6154 20.3036 32.6154 21.4359Z'
      fill='black'
    />
  </svg>
)

export default Pages
